module.exports = __webpack_public_path__ + "img/logo.30d889c1.png";